import axios from 'axios';
import qs from 'qs';

import { isDeploy } from '@/environment';

declare module 'axios' {
  export interface AxiosRequestConfig {
    /**
     * 세컨솔드 API 에러 코드에 대한 핸들러.
     *
     * 핸들러가 있다면, 네트워크 오류 수집을 하지 않습니다.
     */
    aclosetErrorHandler?: Record<string, string | (() => React.ReactNode)>;
  }
}

let baseURL = import.meta.env.VITE_PUBLIC_ACLOSET_API_URL;

if (!isDeploy) {
  const custormBaseURL = localStorage.getItem('api_base_url');

  if (custormBaseURL !== null && custormBaseURL !== '') {
    baseURL = custormBaseURL;
  }
}

const axiosInstance = axios.create({
  baseURL: baseURL,
  headers: {
    mode: 'cors',
    'Content-Type': 'application/json',
    credentials: 'same-origin',
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  },
  paramsSerializer: {
    serialize: params => {
      return qs.stringify(params, { arrayFormat: 'repeat' });
    },
  },
});

export default axiosInstance;
